<template>
  <div>
    <el-upload
        list-type="picture-card"
        :file-list="value"
        :disabled='disabled'
        action="https://upload.qiniup.com/"
        :http-request="up"
        :on-change='change'
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {get_qiniu_token, toQiniu} from '../api/open'

export default {
  name: "imgListUpdate",
  props:{
    value:{
      default:[]
    },
    disabled:{
      default: false
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    change(file){
      let formdata = new FormData()
      formdata.append('file', file.raw)
      get_qiniu_token().then(res => {
        let data = res.data
        if (data.code === '000') {
          this.upToken = data.content.upToken
          this.domain = data.content.domain
          formdata.append('token', this.upToken)
          this.updataQiniu(formdata,file.raw.uid)
        }
      }).catch(err => {
        console.log(err);
      })
    },
    up(file) {

    },
    updataQiniu(para,uid) {
      toQiniu(para).then(res => {
        let data = res.data
        let img = 'https://' + this.domain + '/' + data.key
        let value=this.value
        value.push({url:img,uid:uid})
        this.$emit('input',value)
      }).catch(err => {
        console.log(err);
      })
    },

    handleRemove(file, value) {
      let index = this.value.findIndex(val => val.url === file.url)
      this.value.splice(index,1)
      this.$emit('input',this.value)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
}
</script>
<style>
.el-upload-list {
  display: inline-block;
}
</style>
<style scoped lang="scss">

</style>
